
export interface IExtIdsDictionary {
    [index: string]: string;
}

export enum ExternalIds {
    BIM,
    PlantIdentification
}

export type TAutomationApp = {
    id: string;
    description: string;
    name: string;
    schema: string;
    externalIds: IExtIdsDictionary;
    resourceGroupId: string;
}

export interface IAutomationObject {
    id: string;
    description: string;
    name: string;
    schema: string;
    externalIds: IExtIdsDictionary;
    resourceGroupId: string;
}

export interface IAutomationAppComponent  {
    schema: string,
    supportsProcessPanel: boolean,
    Icon: any,
    OverviewPanel?: any | undefined,
    OperatorPanel?: any | undefined,
    ParameterPanel?: any | undefined,
    SystemPanel?: any | undefined,
    ConfigurationPanel?: any | undefined,
    ListPanel?: any | undefined,
    InsightsPanel?: any | undefined,
    SideViewPanel?: any | undefined,
    createConfig?: TObjectCreateConfig | undefined,
    isSmartApp?: boolean | undefined,
    addAppFilter?: (app: IAutomationObject) => boolean | undefined
}


export type TObjectCreateConfig = {
    group: keyof typeof APP_GROUPS,
    name: string,
    description: string,
    defaultState?: any, // this one is used as a "fake" state when showing the panel
    panel: any, // the panel to show
    defaultProperties?: TDefaultProperty[], // these properties are used when creating a new object
}

export const APP_GROUPS = {
    RoomAutomation: 'Room Automation',
    Devices: 'Devices',
    FunctionGroups: 'Function Groups',
    Utilities: 'Utilities',
    AnalogSensors: 'Analog Sensors',
    Aggregates: 'Aggergates',
    SubPlants: 'Sub plants',
    Spaces: 'Spaces',
    Functions: 'Functions',
    Logics: 'Logics',
    ReportsAndStatistics: 'Reports & Statistics',
    DigitalSensors: 'Digital Sensors',
    Plants: 'Plants',
    Energy: 'Energy meters'
}

export type TDefaultProperty = {
    key: string,
    value: any
}
